import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import moment from "moment";
import { commonService } from "../../../utils/commonService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiCall } from "../../../utils/axiosService";
import { apiResponse } from "../../../utils/apiResponse";

import "../../../Assets/Styles/component.css";
import Loader from "../../Loader/Loader";

const RGIByDayofWeek = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    RGIByDayofWeekTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDayOfWeekData = async () => {
    setLoading(true);

    let DayOfWeekResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.MORNING_BRIEFING.GET_MARKET_SHARE,
        body: {
          propertycode:
            para?.propertyDetail?.propertycode || para?.propertyCode,
          selecteddate: para?.asOfDate,
          weekcount: 12,
        },
      },
      false,
    );

    let response = apiResponse(false, DayOfWeekResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data?.summary || [];
      setData(dataFromApi);
    } else {
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      const staticData = [
        { dow: "Sunday", rgi: "98.5" },
        { dow: "Monday", rgi: "102.1" },
        { dow: "Tuesday", rgi: "105.4" },
        { dow: "Wednesday", rgi: "104.8" },
        { dow: "Thursday", rgi: "101.2" },
        { dow: "Friday", rgi: "97.8" },
        { dow: "Saturday", rgi: "106.5" },
        { dow: "Total", rgi: "102.3" },
      ];
      setData(staticData);
      setLoading(false);
    } else {
      if (para?.asOfDate && para?.propertyCode) {
        getDayOfWeekData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api]);

  const daysOrder = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Total",
  ];
  const daysAbbrev = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT", "TOTAL"];

  const safeData = Array.isArray(data) ? data : [];
  const dayValues = daysOrder.map((day) => {
    const match = safeData.find((d) => d.dow === day);
    return match ? parseFloat(match.rgi) : null;
  });

  // Find the day with the minimum RGI to highlight if it's losing
  let minVal = Infinity;
  let worstIndex = -1;
  dayValues.forEach((val, idx) => {
    if (val !== null && val < minVal) {
      minVal = val;
      worstIndex = idx;
    }
  });

  const getColor = (val) => {
    if (val < 100) return "#dc2626"; // red
    if (val > 104) return "#16a34a"; // green
    return "#0f172a"; // dark gray instead of white
  };

  const getStatusText = (val) => {
    if (val < 100) return "losing";
    if (val >= 108) return "winning";
    if (val > 100 && val < 104) return "mixed";
    return "steady";
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          {/* <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID("RGIByDayofWeek","emailIcon", propertyDetailFromRTK?.propertyid)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.RGIByDayofWeekTable,
                  "RGIByDayofWeek",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "RGIByDayofWeek",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.RGIByDayofWeek || "RGIByDayofWeek",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={downloadIcon}
              alt="menuIcon"
              id={commonService.generateGlobalClickTrackerID("RGIByDayofWeek","downloadIcon", propertyDetailFromRTK?.propertyid)}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.RGIByDayofWeekTable,
                  `${para?.propertyCode}-RGIByDayofWeek-${moment(new Date()).format("MMDDYYYY")}`
                )
              }
            />
          </Button> */}
        </div>
      )}

      {loading ? (
        <div className="p-4 text-center">
          <Loader />
        </div>
      ) : (
        <div className="rgi-days-container">
          {dayValues.map((val, index) => {
            // Only render if we have data for this day
            if (val === null) {
              return (
                <div
                  key={daysAbbrev[index]}
                  className={`rgi-day-box-placeholder ${index < 7 ? "rgi-day-box-margin" : ""}`}
                ></div>
              );
            }

            const isWorstAndLosing = index === worstIndex && val < 100;
            const classNames = `rgi-day-box ${index < 7 ? "rgi-day-box-margin" : ""} ${isWorstAndLosing ? "worst-losing" : ""}`;

            return (
              <div
                key={daysAbbrev[index]}
                className={`${classNames} groupiq-card-block`}
              >
                <span className="rgi-day-abbr">{daysAbbrev[index]}</span>
                <span
                  className="rgi-day-value"
                  style={{ color: getColor(val) }}
                >
                  {val.toFixed(2)}
                </span>
                {/* <span className="rgi-day-status">{getStatusText(val)}</span> */}
              </div>
            );
          })}
        </div>
      )}
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={"RGIByDayofWeek" + tblids.RGIByDayofWeekTable}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default RGIByDayofWeek;
